export default __webpack_public_path__ + "static/media/android.25655ccb.svg";